import { APIContextActions } from '../../api/APIContext';
import { Persistence } from '../../persistence/Persistence';
import { FlowStepRuleFunctionVariadic } from '../flow-engine';

export const rule: FlowStepRuleFunctionVariadic = async function useRule(_apiContext: APIContextActions) {
  return !Persistence.getPartnerLevel() || !Persistence.getPartnerLevelId();
};
